import { TextVariants } from '@lichtblick/theme';

import { Container, UserSection } from './ChatInput.styles';
import { FieldSection, FieldSectionProps } from './partials/FieldSection';

import { ChatAvatar } from '../ChatAvatar';
import { Text } from '../Text';

export const ChatInput = (props: FieldSectionProps) => {
  return (
    <Container>
      <UserSection>
        <ChatAvatar isCraftsman={false} />
        <Text $variant={TextVariants.title.l}>You</Text>
      </UserSection>
      <FieldSection {...props} />
    </Container>
  );
};
